import { TrashSquareIcon } from '../../../../../assets/icons/common';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';

interface Props {
    title: string;
    /** Full question shown to the applicant, naming what is about to go. */
    question: string;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

/** Confirmation asked before anything is removed from the profile. */
function ConfirmDeleteModal(props: Props) {
    const { title, question, loading, onCancel, onConfirm } = props;

    return (
        <Modal
            size='sm'
            title={title}
            actions='both'
            closeFunc={onCancel}
            icon={<TrashSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: onCancel,
            }}
            confirmButton={{
                text: 'Delete',
                type: 'Error',
                loading: loading,
                onClick: onConfirm,
            }}
        >
            <h3>{question}</h3>
        </Modal>
    );
};

export default ConfirmDeleteModal;
